query GetAudienceForCount($id: ID!) {
    audience(id: $id) {
        id
        name
        htmlUrl
        htmlUrlPath
        htmlUrlPathForList
        membershipStats {
            totalCount {
                value
                suffix
                prefix
                formatted
            }
        }
        createdTime
        isRecentlyCreated
        description
    }
}
